<div class="modal-header" medptevlog>
  <h2 class="modal-title" id="modal-title">Electronic Signature</h2>
  <span type="button" class="btn-close" (click)="modal.dismiss('')" medpt-log-action="CloseModel" [attr.medpt-log-message]="'Close '+eSignInputModel.DocumentType+' Sign Model'"></span>
</div>
<div class="modal-body" medptevlog>
  <form class="form-horizontal" [formGroup]="esignform" (ngSubmit)="onSubmitEpaSign()" id="esignform">
    <div class="row">
      <div class="col col-md-12">

      </div>
    </div>
    <div class="row">
      <div class="alert alert-info" *ngIf="showWarning">
        <span class="icon-info alertico"></span>
        <label class="notify-msg p-1">
          {{warningMsg}}
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-5">
        <h5><strong>{{contentTitle}}</strong></h5>
        <div class="sign-selector p-4" style="height: 300px;">
          <div class="d-flex align-items-center justify-content-start">
            <img src="{{cdnEndPoint}}/triport/icons/submenu/success_dark.svg" />
            <label class="m-0 ms-2">{{description}}</label>
          </div>
          <div class="py-4">
            <mat-divider></mat-divider>
          </div>
          <div class="d-flex">
            <h6><strong>{{title}}</strong></h6>
          </div>
        </div>
      </div>
      <div class="col col-md-7" *ngIf="!isExternalLogin">
        <h5><strong>Sign electronically</strong></h5>
        <div class="col">
          <label class="form-label">Full Name</label>
          <input type="text" disabled value="{{fullName}}" />
        </div>
        <div class="col">
          <label>MedPoint ID</label>
          <input type="text" disabled value="{{userName}}" />
        </div>
        <div class="col">
          <label>Password</label>
          <input type="password" class="mb-0" formControlName="password" [ngClass]="{'input-validation-error': !esignform.controls['password'].valid && esignform.controls['password'].touched}" placeholder="Enter password" />
          <span class="text-danger small" *ngIf="(esignform.controls['password'].touched || submitted) && esignform.controls['password'].errors?.['required']">Password is required</span>
        </div>
        <div class="col">
          <p class="small mt-2">By providing my Name, MedPoint ID and Password, I agree that this information will be the electronic representation of my signature for all purposes when I supply them.</p>
        </div>
      </div>
      <div class="col col-md-7" *ngIf="isExternalLogin">
        <h5><strong>Sign electronically</strong></h5>
        <div class="col">
          <label class="form-label">Full Name</label>
          <input type="text" disabled value="{{fullName}}" />
        </div>
        
        <div class="col">
          <p class="small mt-2"><strong>When you click the Sign button, your authentication provider will prompt you for your ID and password.</strong></p>
        </div>
        <div class="col">
          <p class="small mt-2">By providing my Name, ID and Password, I agree that this information will be the electronic representation of my signature for all purposes when I supply them.</p>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer" medptevlog>
  <button type="button" class="secondaryBtn" (click)="modal.dismiss('')" medpt-log-action="CloseModel" [attr.medpt-log-message]="'Close '+eSignInputModel.DocumentType+' Sign Model'">Cancel</button>
  <button type="submit" class="primaryBtn" form="esignform" ngbAutofocus *ngIf="!isExternalLogin" medpt-log-action="Sign" [attr.medpt-log-message]="'Sign in called for '+eSignInputModel.DocumentType">Submit</button>
  <button type="button" class="primaryBtn" [disabled]="submitted" (click)="onSignClick()" ngbAutofocus *ngIf="isExternalLogin" medpt-log-action="Sign" [attr.medpt-log-message]="'External sign in called for '+eSignInputModel.DocumentType">Sign</button>
</div>

